import moment from "moment";
import Vue from "vue";
import MasterService from "@/services/MasterService";
import DistributorService from "@/services/DistributorService";
import {
  addAllKeyWordsIntoArrays,
  addAllKeyWordsIntoArrays_2
} from "@/helper/collection";

import { router } from "@/router";

const state = {
  CinemasList: [],
  DistributorsList: [],
  DistributorsMasterMovieList: [],
  PosUsersList: [],
  AggregatorUserList: [],
  PaymentTypesList: [],
  OfferVoucherTypesList: [],
  OrgImage: null,
  noOfScreens: 1,
  currentCinemaIndex: 0,
  BacktoSeatLayout: false,
  DaysList: [],
  RawMaterialCategoryList: [],
  isCinemaManager: false,
  dropdownSelectedCinema: undefined,
  global_options_latest: [],
  organizationDetails: {},
  hotPickModules: [],
  isGogoCinema: "",
  health_meta: {
    git: {},
    os: {},
    process: {}
  },
  mobileSidebar: false,
  isMobile: false,
  isReprint: false,
  selectSeatCountPopUp: 10,
  TimeFormat: "HH:mm",
  TEST_SETUP: false,
  show_send_sms_section: "Y",
  direct_print: "N",
  pos_amount_calculation_check: "Y",
  pos_final_page_standby_time: "3",
  contentLangArray: [],
  selected_content_language: null,
  area_lang_id: null,
  cinema_settings: [],
  cine_seat_release_time: 0,
  pos_seat_release_alert_time_in_sec: 60,
  seat_extend_timer: 0,
  client_setup_name: ""
};

const mutations = {
  SET_POS_FINAL_PAGE_STANDBY_TIME_IN_MINS: (state, payload) => {
    console.log("Payload", payload);
    if (!isNaN(payload) && payload > 0) {
      state.pos_final_page_standby_time = parseInt(payload);
    } else {
      state.pos_final_page_standby_time = 3;
    }
  },
  SET_DROPDOWN_AREA_LANGUAGE: (state, payload) => {
    state.selected_content_language = payload;
    state.area_lang_id = payload.lang_id;
    window.localStorage.setItem("area_lang", JSON.stringify(payload));
  },
  SET_CLIENT_SETUP_NAME: (state, payload) => {
    state.client_setup_name = payload;
  },
  SET_CONTENT_LANGUAGES: (state, payload) => {
    state.contentLangArray = payload;
  },
  POS_SEAT_EXTEND_ALERT_IN_SEC: (state, payload) => {
    console.log("Payload", payload);
    if (!isNaN(payload) && payload > 60) {
      state.pos_seat_release_alert_time_in_sec = parseInt(payload);
    } else {
      state.pos_seat_release_alert_time_in_sec = 60;
    }
  },
  SET_CINEMA_SEAT_SETTINGS: (state, payload) => {
    state.cinema_settings = payload;
    state.cine_seat_release_time = payload[0].cine_seat_release_time_in_mins;
    let posSeatPopinMins = parseInt(state.pos_seat_release_alert_time_in_sec) / 60;
    if (!isNaN(payload[0].cine_seat_release_time_in_mins) && (payload[0].cine_seat_release_time_in_mins > posSeatPopinMins)) {
      state.seat_extend_timer = (parseFloat(payload[0].cine_seat_release_time_in_mins) - parseFloat(posSeatPopinMins)) * 60000
    } else {
      state.seat_extend_timer = 0;
    }
  },
  SET_POS_AMOUNT_VALIDATION: (state, payload) => {
    state.pos_amount_calculation_check = payload;
  },
  SET_REPRINT: (state, payload) => {
    state.isReprint = payload;
  },
  SET_DIRECT_PRINT: (state, payload) => {
    state.direct_print = payload;
  },
  SET_SHOW_SMS_SECTION: (state, payload) => {
    state.show_send_sms_section = payload;
  },
  SET_GOGO_CINEMA: (state, payload) => {
    state.isGogoCinema = payload;
  },
  SET_ORG_DETAILS: (state, payload) => {
    state.organizationDetails = payload;
  },
  SET_HOT_PICKS_MODULES: (state, payload) => {
    state.hotPickModules = payload;
  },
  SET_GLOBAL_OPTIONS: (state, payload) => {
    state.global_options_latest = payload;
  },
  SET_HEALTH_META: (state, payload) => {
    state.health_meta = payload;
  },
  SET_POS_USERS_LIST: (state, payload) => {
    state.PosUsersList = addAllKeyWordsIntoArrays(payload);
  },
  SET_AGGREGATOR_USERS_LIST: (state, payload) => {
    state.AggregatorUserList = addAllKeyWordsIntoArrays(payload);
  },
  SET_PAYMENT_TYPES_LIST: (state, payload) => {
    state.PaymentTypesList = payload;
    // addAllKeyWordsIntoArrays(
    //   payload,
    //   "pm_payment_mode"
    // );
  },
  SET_OFFERS_VOUCHER_TYPES_LIST: (state, payload) => {
    state.OfferVoucherTypesList = payload;
  },
  SET_CINEMAS_LIST: (state, payload) => {
    console.log("payload :", payload);
    state.CinemasList = payload;
  },
  SET_RAW_MATERIAL_CATEGORY_LIST: (state, payload) => {
    state.RawMaterialCategoryList = addAllKeyWordsIntoArrays(
      payload,
      "rmc_category"
    );
  },
  SET_DISTRIBUTORS_LIST: (state, payload) => {
    state.DistributorsList = payload;
  },
  SET_DISTRIBUTORS_MASTER_MOVIES_LIST: (state, payload) => {
    state.DistributorsMasterMovieList = payload;
  },
  //setup mutations
  SET_ORG_IMAGE: (state, payload) => {
    state.OrgImage = payload;
  },
  SET_NO_SCREENS: (state, payload) => {
    state.noOfScreens = payload;
  },
  SET_CURRENT_CINEMA_INDEX: (state, payload) => {
    state.currentCinemaIndex = 1;
  },
  SET_BoxOfficeFnb_Back_SeatLayout: (state, payload) => {
    state.BacktoSeatLayout = true;
  },
  SET_WEEK_DAYS: (state, payload) => {
    console.log("payload :", payload);
    state.DaysList = payload;
  },
  IS_CINEMA_MANAGER: state => {
    state.isCinemaManager = true;
  },
  IS_NOT_CINEMA_MANAGER: state => {
    state.isCinemaManager = false;
  },
  SET_DROPDOWN_SELECTED_CINEMA: (state, payload) => {
    state.dropdownSelectedCinema = payload;
  },
  SET_MOBILE_SIDEBAR: (state, payload) => {
    state.mobileSidebar = payload;
  },
  SET_IS_MOBILE: (state, payload) => {
    state.isMobile = payload;
  },
  SET_TEST_SETUP: (state, payload) => {
    let TestSetup = false;
    if (payload && payload == "Y") {
      TestSetup = true;
    } else {
      TestSetup = false;
    }
    state.TEST_SETUP = TestSetup;
  },
  SET_TIME_FORMAT: (state, payload) => {
    console.log("Payload", payload);
    let format = "HH:mm";
    if (payload.toLowerCase() == "n") {
      format = "hh:mm:A";
    } else if (payload.toLowerCase() == "y") {
      format = "HH:mm";
    } else {
      format = "HH:mm";
    }
    state.TimeFormat = format;
    window.localStorage.setItem("TimeFormat", format);
  },
  SET_SEAT_POPUP_COUNT: (state, payload) => {
    console.log("Payload", payload);
    if (!isNaN(payload) && payload > 0 && payload <= 10) {
      state.selectSeatCountPopUp = parseInt(payload);
    } else if (payload <= 0) {
      state.selectSeatCountPopUp = 1;
    } else {
      state.selectSeatCountPopUp = 10;
    }
  }
};

const actions = {
  onChangeAreaLanguage: ({ dispatch, commit, state }, payload) => {
    commit('SET_DROPDOWN_AREA_LANGUAGE', payload)
  },
  fetchGlobalOptions: ({ commit }, payload) => {
    MasterService.GetGlobalOptions().then(response => {
      const { data } = response;
      if (data && data.status && data.Records.length > 0) {
        const CLIENT_SETUP_NAME = data.Records.find(
          go => go.go_key == "CLIENT_SETUP_NAME"
        );
        commit("SET_CLIENT_SETUP_NAME", CLIENT_SETUP_NAME.go_value);
        
        const IS_GOGO_CINEMA = data.Records.find(
          go => go.go_key == "IS_GOGO_CINEMA"
        );
        let isGogoCinema = IS_GOGO_CINEMA.go_value == "Y" ? true : false;
        commit("SET_GOGO_CINEMA", IS_GOGO_CINEMA.go_value);
        console.log("IS_GOGO_CINEMA.go_value", isGogoCinema);
        commit("SET_GLOBAL_OPTIONS", data.Records);

        const POS_INPUT_CASH_VALIDATION = data.Records.find(
          go => go.go_key == "POS_INPUT_CASH_VALIDATION"
        );

        if (POS_INPUT_CASH_VALIDATION && POS_INPUT_CASH_VALIDATION.go_value) {
          commit(
            "SET_POS_AMOUNT_VALIDATION",
            POS_INPUT_CASH_VALIDATION.go_value
          );
        }

        const POS_FINAL_PAGE_STANDBY_TIME_IN_MINS = data.Records.find(
          go => go.go_key == "POS_FINAL_PAGE_STANDBY_TIME_IN_MINS"
        );

        if (
          POS_FINAL_PAGE_STANDBY_TIME_IN_MINS &&
          POS_FINAL_PAGE_STANDBY_TIME_IN_MINS.go_value
        ) {
          commit(
            "SET_POS_FINAL_PAGE_STANDBY_TIME_IN_MINS",
            POS_FINAL_PAGE_STANDBY_TIME_IN_MINS.go_value
          );
        }

        const POS_SEAT_EXTEND_ALERT_IN_SEC = data.Records.find(
          go => go.go_key == "POS_SEAT_EXTEND_ALERT_IN_SEC"
        );

        if (
          POS_SEAT_EXTEND_ALERT_IN_SEC &&
          POS_SEAT_EXTEND_ALERT_IN_SEC.go_value
        ) {
          commit(
            "POS_SEAT_EXTEND_ALERT_IN_SEC",
            POS_SEAT_EXTEND_ALERT_IN_SEC.go_value
          );
        }

        const SHOW_SMS_SECTION = data.Records.find(
          go => go.go_key == "SHOW_POS_SEND_SMS_SECTION"
        );

        commit("SET_SHOW_SMS_SECTION", SHOW_SMS_SECTION.go_value);

        const CONTENT_LANG_ARRAY = data.Records.find(
          go => go.go_key == "KIOSK_LANGUAGE"
        );

        commit('SET_CONTENT_LANGUAGES', JSON.parse(CONTENT_LANG_ARRAY.go_value))

        const SELECT_SEAT_POPUP_COUNT = data.Records.find(
          go => go.go_key == "SELECT_SEAT_COUNT_POPUP"
        );

        const TIME_FORMAT = data.Records.find(
          go => go.go_key == "24_HRS_FORMAT"
        );
        commit("SET_TIME_FORMAT", TIME_FORMAT.go_value);

        const POS_DIRECT_PRINT = data.Records.find(
          go => go.go_key == "POS_DIRECT_PRINT"
        );
        commit("SET_DIRECT_PRINT", POS_DIRECT_PRINT.go_value);

        const TEST_SETUP = data.Records.find(go => go.go_key == "TEST_SETUP");
        commit("SET_TEST_SETUP", TEST_SETUP.go_value);

        commit("SET_SEAT_POPUP_COUNT", SELECT_SEAT_POPUP_COUNT.go_value);
      } else {
        console.log("Erro in fetching global options");
      }
    });
    commit("SET_GLOBAL_OPTIONS", payload);
  },
  fetchHealthMeta: ({ commit }) => {
    let payload = {
      git: {},
      os: {},
      process: {}
    };

    MasterService.GetHealthMeta()
      .then(response => {
        const { data } = response;
        payload = data;
      })
      .catch(console.log)
      .finally(() => {
        commit("SET_HEALTH_META", payload);
      });
  },
  fetchOrgDetails: ({ commit }, payload) => {
    MasterService.GetOrgDetails().then(response => {
      const { data } = response;
      if (data && data.status && data.Records.length > 0) {
        commit("SET_ORG_DETAILS", data.Records[0]);
      } else {
        console.log("Error", data.message);
      }
    });
  },
  setDropdownCinema: ({ commit }, payload) => {
    MasterService.GetCinemas()
      .then(response => {
        const { data } = response;
        if (data.status) {
          if (data.Records && data.Records.length == 1) {
            window.localStorage.setItem(
              "dropDownCinema",
              JSON.stringify(data.Records[0])
            );
            commit("SET_DROPDOWN_SELECTED_CINEMA", data.Records[0]);
          } else {
            if (window.localStorage.getItem("dropDownCinema")) {
              let cinemaObj = JSON.parse(
                window.localStorage.getItem("dropDownCinema")
              );
              commit("SET_DROPDOWN_SELECTED_CINEMA", cinemaObj);
            }
          }
        } else {
          console.log("Error", data.message);
        }
      })
      .catch(err => {
        console.log("Error", err);
      });
  },
  boxOfficefnb_back_seatlayout: ({ commit }, payload) => {
    commit("SET_BoxOfficeFnb_Back_SeatLayout", payload);
  },
  selectDropdownCinema: ({ commit }, payload) => {
    window.localStorage.setItem("dropDownCinema", JSON.stringify(payload));
    commit("SET_DROPDOWN_SELECTED_CINEMA", payload);
  },
  fetchCinemasList: ({ dispatch, commit, state }, payload) => {
    // let body = {
    //   tableName: "ms_cinemas",
    //   cine_is_active: "Y",
    // };
    // if (payload && payload['cinemaId'] && String(payload.cinemaId).length > 0) {
    //   body['cine_id'] = payload.cinemaId
    // }
    MasterService.GetCinemas({ cine_id: payload.cinemaId })
      .then(async response => {
        const { data } = response;
        if (data && data.status) {
          data.Records.length > 0
            ? commit("SET_CINEMAS_LIST", data.Records || [])
            : "";
          if (
            payload &&
            payload["cinemaId"] &&
            String(payload.cinemaId).length > 0
          ) {
            await commit("IS_CINEMA_MANAGER");
            // await dispatch('onTransactionRefundsDropDownHandler',{name: 'isCinema',selectedItem:{cine_id: data.Records[0].cine_id,cine_name:data.Records[0].cine_name}})
            // await dispatch('onSummaryReportDropdownHandler',{name: 'isCinema',selectedItem:{cine_id: data.Records[0].cine_id,cine_name:data.Records[0].cine_name}})
            // await dispatch('onPerformanceReportFlagHandler',{
            //   event: null,
            //   name: "isCinema",
            //   value: data.Records[0].cine_id
            // });
          } else {
            await commit("IS_NOT_CINEMA_MANAGER");
            // await commit('UNSELECT_CINEMA')
            // await commit('UNSELECT_SUMMARY_CINEMA')
            // await commit('UNSELECT_PERFORMANCE_CINEMA')
          }
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        console.log("error >>>>>>>>>:>> ", error);
        Vue.toasted.show("Catch Error on MasterStore fetchCinemasList", error);
      });
  },
  fetchRawMaterialCategory: ({ dispatch, commit, state }, payload) => {
    let body = {
      tableName: "ms_raw_material_category",
      rmc_is_active: "Y"
    };
    MasterService.GetActiveList(body)
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          data.Records.length > 0
            ? commit("SET_RAW_MATERIAL_CATEGORY_LIST", data.Records || [])
            : "";
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on MasterStore fetchCinemasList", error);
      });
  },
  fetchDistributorsList: ({ dispatch, commit, state }, payload) => {
    let body = {
      tableName: "ms_distributors",
      d_is_active: "Y"
    };
    // screen_id: screen.screen_id
    MasterService.GetActiveList(body)
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          data.Records.length > 0
            ? commit("SET_DISTRIBUTORS_LIST", data.Records || [])
            : "";
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error =>
        Vue.toasted.show(
          "Catch Error on MasterStore fetchDistributorsList",
          error
        )
      );
  },
  fetchDistributorsActiveMasterMovie: (
    { dispatch, commit, state },
    payload
  ) => {
    DistributorService.GetDistributorActiveMasterMovie()
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          if (data.Records.length > 0)
            commit("SET_DISTRIBUTORS_MASTER_MOVIES_LIST", data.Records || []);
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error =>
        Vue.toasted.show(
          "Catch Error on MasterStore fetchDistributorsActiveMasterMovie",
          error
        )
      );
  },
  fetchPosUsersList: ({ dispatch, commit, state }, payload) => {
    let body = {
      role_id: "4, 8",
      cinema_id: payload.cinema_id
    };
    MasterService.GetActiveUsersAccordingRolesList(body)
      .then(response => {
        const { data } = response;
        if (data && data.status && data.Records) {
          data.Records.length > 0
            ? commit("SET_POS_USERS_LIST", data.Records || [])
            : "";
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        console.log("error :>> ", error);
        Vue.toasted.show("Catch Error on MasterStore fetchPosUsersList", error);
      });
  },
  fetchAggregatorsUsersList: ({ dispatch, commit, state }, payload) => {
    let body = {
      tableName: "users",
      role_id: "10"
    };
    MasterService.GetActiveList(body)
      .then(response => {
        const { data } = response;
        if (data && data.status && data.Records) {
          data.Records.length > 0
            ? commit("SET_AGGREGATOR_USERS_LIST", data.Records || [])
            : "";
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on MasterStore fetchPosUsersList", error);
      });
  },
  fetchPaymentTypesList: ({ dispatch, commit, state }, payload) => {
    let body = {
      tableName: "ms_payment_modes",
      pm_is_active: "Y"
    };
    MasterService.GetActiveList(body)
      .then(response => {
        const { data } = response;
        if (data && data.status) {
          data.Records.length > 0
            ? commit("SET_PAYMENT_TYPES_LIST", data.Records || [])
            : "";
        } else Vue.toasted.show(data.message || "Opps! Something went wrong");
      })
      .catch(error => {
        Vue.toasted.show(
          "Catch Error on MasterStore fetchPaymentTypesList",
          error
        );
      });
  },
  //setup actions
  setOrgImage: ({ dispatch, commit, state }, payload) => {
    commit("SET_ORG_IMAGE", payload);
  },
  setNoOfScreens: ({ dispatch, commit, state }, payload) => {
    commit("SET_NO_SCREENS", payload);
  },
  setCurrentCinemaIndex: ({ dispatch, commit, state }, payload) => {
    commit("SET_CURRENT_CINEMA_INDEX", payload);
  },
  globalRemoveFile: ({ dispatch, commit, state }, payload) => {
    // /api/admin / removereportfile
    MasterService.GlobalRemoveFile(payload)
      .then(response => {
        const { data } = response;

        // console.log('data :', data);
      })
      .catch(error => {
        console.log("error :", error);
      });
  },
  fetchOfferVoucherTypesList: ({ dispatch, commit, state }, payload) => {
    // THIS IS FOR fUTURE
    // let body = {
    //     tableName: "",
    // };
    // MasterService.GetActiveList(body)
    //     .then(response => {
    //         const { data } = response;
    //         if (data && data.status && data.Records.length > 0) commit('SET_OFFERS_VOUCHER_TYPES_LIST', data.Records || []);
    //         else Vue.toasted.show(data.message || 'Opps! Something went wrong');
    //     })
    //     .catch(error => {
    //         Vue.toasted.show("Catch Error on MasterStore fetchOfferVoucherTypesList", error);
    //     });
  },
  fetchDaysList: ({ dispatch, commit, state }, payload) => {
    MasterService.getDays()
      .then(response => {
        const { data } = response;
        commit("SET_WEEK_DAYS", data.data || []);
      })
      .catch(error => {
        Vue.toasted.show("Catch Error on MasterStore fetchWeekDays", error);
      });
  },
  set_dropdown_area_language: ({ dispatch, commit, state }, payload) => {
    let selected_lang = {
      lang_name: 'German',
      lang_id: 52,
      iso_2: 'de',
      iso_3: 'deu'
    }
    if (window.localStorage.getItem("area_lang")) {
      selected_lang = JSON.parse(window.localStorage.getItem("area_lang"));
      commit('SET_DROPDOWN_AREA_LANGUAGE', selected_lang);
    } else {
      if (state.contentLangArray && state.contentLangArray.length > 0) {
        selected_lang = state.contentLangArray.find((x) => x.iso_2.toLowerCase() == 'de') || '';
        commit('SET_DROPDOWN_AREA_LANGUAGE', selected_lang);
      }
    }
  },
  hotPickModule: ({ dispatch, commit, state }, payload) => {
    let body = {
      module_id: payload
    };
    console.log("hotPickModule payload", payload);
    MasterService.hotPickModule(body)
      .then(response => {
        const { data } = response;
        if (data.status) {
          dispatch("fetchUserHotPickModules");
        }
        console.log("hotPickModule data", data);
      })
      .catch(error => Vue.toasted.show("Catch Error on MasterStore", error));
  },
  fetchUserHotPickModules: ({ dispatch, commit, state }, payload) => {
    commit("SET_HOT_PICKS_MODULES", []);
    MasterService.getHotPickModules()
      .then(response => {
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          commit("SET_HOT_PICKS_MODULES", data.Records);
        }
        console.log("getHotPickModules data", data);
      })
      .catch(error => Vue.toasted.show("Catch Error on MasterStore", error));
  },
  setMobileSidebar({ commit }, payload) {
    commit("SET_MOBILE_SIDEBAR", payload);
  },
  setIsMobile({ commit }, payload) {
    commit("SET_IS_MOBILE", payload);
    console.log("set isMobile", payload);
  }
};

const getters = {
  getGlobalOptions: state => state.global_options_latest,
  getHealthMeta: state => state.health_meta,
  getbacktoseatlayout: state => state.BacktoSeatLayout,
  // THIS IS FOR FUTURE
  getOfferVoucherTypesList: state => state.OfferVoucherTypesList,

  getCinemasList: state => state.CinemasList,
  getDistributorsList: state => state.DistributorsList,
  getPosUsersList: state => state.PosUsersList,
  getAggregatorUserList: state => state.AggregatorUserList,
  getPaymentTypesList: state => state.PaymentTypesList,
  getDistributorsMasterMovieList: state => state.DistributorsMasterMovieList,
  getWeekDaysList: state => state.DaysList,
  getRawMaterialCategoryList: state => state.RawMaterialCategoryList,
  //setup store
  getOrgImage: state => state.OrgImage,
  noOfScreens: state => state.noOfScreens,
  currentCinemaIndex: state => state.currentCinemaIndex,
  isCinemaManager: state => state.isCinemaManager,
  getSelectedDropDownCinema: state => state.dropdownSelectedCinema,
  getOrganizationDetails: state => state.organizationDetails,
  getHotPickModules: state => state.hotPickModules,
  isGogoCinema: state => state.isGogoCinema,
  getMobileSidebar: state => state.mobileSidebar,
  getIsMobile: state => state.isMobile,
  isReprint: state => state.isReprint,
  seatCountPopUp: state => state.selectSeatCountPopUp,
  isTestSetup: state => state.TEST_SETUP,
  TimeFormat: state => state.TimeFormat,
  ShowSendSMSSection: state => state.show_send_sms_section,
  DirectPrint: state => state.direct_print,
  POS_AMOUNT_CALCULATION_CHECK: state => state.pos_amount_calculation_check,
  POS_FINAL_PAGE_STANDBY_TIME: state => state.pos_final_page_standby_time,
  CONTENT_LANG_ARRAY: state => state.contentLangArray,
  SELECTED_AREA_LANGUAGE: state => state.selected_content_language,
  AREA_LANG_ID: state => state.area_lang_id,
  POS_SEAT_EXTEND_TIMER: state => state.seat_extend_timer,
  POS_SEAT_ALERT_TIME_IN_SEC: state => state.pos_seat_release_alert_time_in_sec,
  CINE_SEAT_RELEASE_TIME_IN_MINS: state => state.cine_seat_release_time,
  CLIENT_SETUP_NAME: state => state.client_setup_name,
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/MasterStore.js